// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.app-container[data-v-e05f19f6] div.el-tree-node {\n  margin-bottom: 5px;\n}\n.app-container[data-v-e05f19f6] div.el-tree-node__children {\n  margin-top: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
